const lhqs = [
  {
    id: 20000,
    name: 'lhq1',
    detail: 'Kiama LHQ',
    icon: 'lhq',
    locationLatitude: -34.673822,
    locationLongitude: 150.844371,
  },
];

export default lhqs;



// WEBPACK FOOTER //
// ./src/fixtures/lhqs.js